<template>
  <div>
    <div class="row">
      <div class="col-md-8">
        <Heading title="Overview" />
      </div>
    </div>

    <div class="row row-space-4">
      <div class="col-md-6 align-self-center">
        <div class="p-4">
          <img src="@/assets/img/overview.svg" class="img-fluid" />
        </div>
      </div>
      <div class="col-md-6 align-self-center">
        <div class="card bs mb-4">
          <div class="card-body font-weight-normal">
            <h5 class="mb-4">Shop</h5>
            <div class="row mb-4">
              <div class="col-6">
                <label>Name</label>
                <p class="mb-0">{{shopObj.name}}</p>
              </div>
              <div class="col-6">
                <label>Member since</label>
                <p class="mb-0">{{memberSince}}</p>
              </div>
            </div>

            <label>Shopify Domain</label>
            <p class="mb-0"><a :href="'https://' + shopObj.myshopify_domain + '/'" target="_blank" rel="noopener">{{shopObj.myshopify_domain}}</a></p>
          </div>
        </div>

        <div class="card bs">
          <div class="card-body font-weight-normal">
            <h5 class="mb-4">Plan</h5>
            <div class="row">
              <div class="col-6">
                <label>Name</label>
                <p class="mb-0">{{plan | upperFirst}}</p>
              </div>
              <div class="col-6">
                <label>Status</label>
                <p class="mb-0">Active</p>
              </div>
            </div>

            <router-link :to="{ name: 'account_plan' }" class="mt-4 btn btn-primary">Change</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import filters from '@/mixins/filters'

export default {
  mixins: [
    filters
  ],
  computed: mapState(['db', 'shopObj', 'plan', 'memberSince'])
}
</script>
